import { Injectable, NgModule } from '@angular/core';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Platform } from '@ionic/angular';
import { AlertService } from '.';

@Injectable({ providedIn: 'root' })

@NgModule({
})

export class ReceiptService {
  fileName: string;
  toastText: string;

  constructor(
    private file: File,
    private platform: Platform,
    private fileOpener: FileOpener,
    private alertService: AlertService,
    private socialSharing: SocialSharing
  ) {}

  openInDevice(pdfFile: any, fileName: string, toastText: string) {
    if (this.platform.is('cordova')) {
      pdfFile.getBuffer((buffer: any) => {
        const blob = new Blob([buffer], { type: 'application/pdf' });
        // Save the PDF to the data Directory of our App
        this.file
          .writeFile(this.file.dataDirectory, fileName, blob, {
            replace: true,
          })
          .then((fileEntry) => {
            // Open the PDf with the correct OS tools
            console.log(fileEntry, this.file);
            this.alertService.stopLoading();
            this.alertService.standardToast(this.toastText + ' downloaded', 'bottom');
            setTimeout(() => {
              if (this.platform.is('ios')) {
                this.fileOpener.open(
                  this.file.dataDirectory + fileName,
                  'application/pdf'
                );
              } else if (this.platform.is('android')) {
                this.socialSharing.share(this.fileName, null,  this.file.dataDirectory + this.fileName, null);
              }
            }, 500);
          }
        );
      });
    } else {
      // Open PDF in browser
      this.alertService.stopLoading();
      pdfFile.download(fileName);
    }
    this.fileName = fileName;
    this.toastText = toastText;
  }
}
